/**
 * API Configuration Utility
 * Handles API URL detection for development and production environments
 */

/**
 * Get the API base URL based on environment
 * Priority:
 * 1. REACT_APP_API_URL environment variable (explicitly set)
 * 2. Auto-detect from window.location (production)
 * 3. Default to localhost:5000 (development)
 */
export const getApiBaseUrl = (): string => {
  // If explicitly set, use it
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Auto-detect production environment
  const isProduction = window.location.hostname !== 'localhost' && 
                       window.location.hostname !== '127.0.0.1' &&
                       window.location.protocol === 'https:';

  if (isProduction) {
    // In production, try to use the same domain or known backend URL
    // Default to Cloud Run backend URL pattern
    const hostname = window.location.hostname;
    
    // If on prowess.corpcrunch.io, use the known backend URL
    if (hostname.includes('prowess.corpcrunch.io') || hostname.includes('corpcrunch.io')) {
      return 'https://prowess-backend-1044410669142.us-central1.run.app';
    }
    
    // Otherwise, try to construct from current domain
    // This is a fallback - should set REACT_APP_API_URL explicitly
    console.warn('⚠️ REACT_APP_API_URL not set. Using auto-detected URL. Please set REACT_APP_API_URL in Vercel environment variables.');
    return 'https://prowess-backend-1044410669142.us-central1.run.app';
  }

  // Development - use localhost
  return 'http://localhost:5000';
};

/**
 * Check if we're in production environment
 */
export const isProduction = (): boolean => {
  return window.location.hostname !== 'localhost' && 
         window.location.hostname !== '127.0.0.1' &&
         window.location.protocol === 'https:';
};

/**
 * Check if Stripe should be loaded (requires HTTPS in production)
 */
export const shouldLoadStripe = (): boolean => {
  // In development, HTTP is fine
  if (!isProduction()) {
    return true;
  }
  
  // In production, require HTTPS
  return window.location.protocol === 'https:';
};

